class Storage {
  /**
   * Facility to remove a set of keys
   * @param {[string]} args
   */
  static remove(...args) {
    args.forEach((key) => window.localStorage.removeItem(key));
  }

  //RIMOSSE PERSIST perchè persist lo fa la libreria redux-persist il retrieve lo facciamo con
  // retrieveLocalStorage

  // /**
  //  * Facility to store things in localstorage
  //  * @param {string} key
  //  * @param {Object} data
  //  */
  // static persist(key, data) {
  //     window.localStorage.setItem(key, JSON.stringify(data));
  // }

  /**
   * Facility to extract and parse data from local storage
   * @param key
   * @returns {*}
   */
  static retrieve(key) {
    const data = window.localStorage.getItem(key);
    if (!data) return null;
    try {
      return JSON.parse(data);
    } catch (e) {
      console.error("Error while parsing data from storage", e);
      return null;
    }
  }

  static retrieveLocalStorage() {
    return Storage.retrieve("persist:root");
  }
}

export const retrieveIsAuth = () => {
  const app = Storage.retrieveLocalStorage()?.app;
  if (app) {
    return JSON.parse(app).isAuth;
  }
};

export const retrieveRole = () => {
  const app = Storage.retrieveLocalStorage()?.app;
  if (app) {
    return JSON.parse(app).role;
  }
};
export const retrieveToken = () => {
  const app = Storage.retrieveLocalStorage()?.app;
  if (app) {
    return JSON.parse(app).accessToken;
  }
};

export const retrieveWhitelabel = () => {
  const whitelabelSlice = Storage.retrieveLocalStorage()?.whitelabelSlice;
  if (whitelabelSlice) {

    return JSON.parse(whitelabelSlice);
  }
};

export default Storage;
